import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    next()
    return
  }
  next('/home')
}

const ifAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  next('/')
}

const ifAuthenticatedValitationUser = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  localStorage.setItem('pathValidationUser', to.path)
  next('/')
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../components/Login.vue'),
    beforeEnter: ifNotAuthenticated
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/signup_apartment',
    name: 'signup_apartment',
    component: () => import('../views/signup_apartment.vue')
  },
  {
    path: '/validavivienda/:token',
    name: 'valida_vivienda',
    component: () => import('../views/admin/valida_vivienda.vue')
  },
  {
    path: '/fraccionamientos',
    name: 'fraccionamientos',
    component: () => import('../views/super_admin/housing_units.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/managers',
    name: 'managers',
    component: () => import('../views/super_admin/managers.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/department_manager',
    name: 'department_manager',
    component: () => import('../views/admin/department_manager.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/historical_superadmin',
    name: 'historical_superadmin',
    component: () => import('../views/super_admin/historical_superadmin.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/casas',
    name: 'casas',
    component: () => import('../views/admin/houses.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/notices',
    name: 'notices',
    component: () => import('../views/admin/generic_notices.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/financial_statements',
    name: 'financial_statements',
    component: () => import('../views/admin/notices.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/parcel',
    name: 'parcel',
    component: () => import('../views/common/parcel.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/directory',
    name: 'directory',
    component: () => import('../views/admin/directory.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/staff',
    name: 'staff',
    component: () => import('../views/admin/staff.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/areas',
    name: 'areas',
    component: () => import('../views/admin/areas.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/sports_schedules',
    name: 'sports_schedules',
    component: () => import('../views/admin/sports_schedules.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/reservation',
    name: 'reservation',
    component: () => import('../views/admin/reservation.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf',
    name: 'golf',
    component: () => import('../views/admin/golf.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/sports',
    name: 'sports',
    component: () => import('../views/admin/sports.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/courts',
    name: 'courts',
    component: () => import('../views/admin/courts.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/account_statements',
    name: 'account_statements',
    component: () => import('../views/admin/account_statements.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/account_statements_main_resident',
    name: 'account_statements_main_resident',
    component: () => import('../views/main_resident/account_statements_main_resident.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/main_resident/reports'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/main_residents',
    name: 'main_residents',
    component: () => import('../views/admin/main_residents.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/main_residents_2',
    name: 'main_residents_2',
    component: () => import('../views/admin/main_residents_2'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/guards',
    name: 'guards',
    component: () => import('../views/admin/guards.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/guardhouses',
    name: 'guardhouses',
    component: () => import('../views/admin/guard_houses.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/settings.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/invitation',
    name: 'invitation',
    component: () => import('../views/admin/invitation.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/signup_apartment_success',
    name: 'signup_apartment_success',
    component: () => import('../views/common/signUpApartmentSuccess.vue')
  },
  {
    path: '/preregistration/:token',
    name: 'preregistration',
    component: () => import('../views/common/preregistration.vue')
  },
  {
    path: '/data_correction/:code_correction',
    name: 'data_correction',
    component: () => import('../views/common/data_correction.vue')
  },
  {
    path: '/self_validate/:token',
    name: 'self_validate',
    component: () => import('../views/common/self_validate.vue')
  },
  {
    path: '/booth_registration/:token',
    name: 'booth_registration',
    component: () => import('../views/guard/booth_registration.vue')
  },
  {
    path: '/terms_conditions',
    name: 'terms_conditions',
    component: () => import('../views/public/terms_conditions')
  },
  {
    path: '/notice_privacy',
    name: 'notice_privacy',
    component: () => import('../views/public/notice_privacy')
  },
  {
    path: '/notice_privacy_club',
    name: 'notice_privacy_club',
    component: () => import('../views/public/notice_privacy_club')
  },
  {
    path: '/validationuser/:token',
    name: 'validationuser',
    component: () => import('../views/common/validationuser.vue'),
    beforeEnter: ifAuthenticatedValitationUser
  },
  {
    path: '/validate_guest/:code_correction',
    name: 'validate_guest',
    component: () => import('../views/common/validate_guest.vue'),
    beforeEnter: ifAuthenticatedValitationUser
  },
  {
    path: '/user_confirmed_successfully',
    name: 'user_confirmed_successfully',
    component: () => import('../views/common/user_confirmed_successfully.vue')
  },
  {
    path: '/user_removed_successfully',
    name: 'user_removed_successfully',
    component: () => import('../views/common/user_removed_successfully.vue')
  },
  {
    path: '/user_invalidate_successfully',
    name: 'user_invalidate_successfully',
    component: () => import('../views/common/user_invalidate_successfully.vue')
  },
  {
    path: '/reset_password',
    name: 'reset_password',
    component: () => import('../views/common/reset_password.vue')
  },
  {
    path: '/reset_password_done',
    name: 'reset_password_done',
    component: () => import('../views/common/reset_password_done.vue')
  },
  {
    path: '/register/success',
    name: 'register_success',
    component: () => import('../views/common/register_success.vue')
  },
  {
    path: '/self_validate_data/success',
    name: 'register_success',
    component: () => import('../views/common/self_validate_success.vue')
  },
  {
    path: '/qrcode/:qrcode',
    name: 'qr_code',
    component: () => import('../views/public/qr_code.vue')
  },
  {
    path: '/residents',
    name: 'residents',
    component: () => import('../views/main_resident/residents.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/workers',
    name: 'workers',
    component: () => import('../views/main_resident/workers.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/workers_admin',
    name: 'workers_admin',
    component: () => import('../views/admin/workers_admin.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/print',
    name: 'print',
    component: () => import('../views/admin/print'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkin_checkout',
    name: 'checkin_checkout',
    component: () => import('../views/guard/checkin_checkout.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkin_checkout_qr/:tab',
    name: 'checkin_checkout_qr',
    component: () => import('../views/guard/checkin_checkout_qr.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/checkin_checkout_qr2/:tab',
    name: 'checkin_checkout_qr2',
    component: () => import('../views/guard/checkin_checkout_qr2.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/access_without_code',
    name: 'access_without_code',
    component: () => import('../views/guard/access_without_code.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/access_without_code_cam',
    name: 'access_without_code_cam',
    component: () => import('../views/guard/access_without_code_cam.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/historical',
    name: 'historical',
    component: () => import('../views/common/historical.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/historical_no_code',
    name: 'historical_no_code',
    component: () => import('../views/common/historical_no_code.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/current_invitations',
    name: 'current_invitations',
    component: () => import('../views/guard/current_invitations.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/courts',
    name: 'golf_courts',
    component: () => import('../views/admin/golf/courts.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/reservations',
    name: 'golf_reservations',
    component: () => import('@/views/admin/golf/reservations.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/blacklist',
    name: 'golf_blacklist',
    component: () => import('@/views/admin/golf/blacklist.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/caddies',
    name: 'golf_caddies',
    component: () => import('@/views/admin/golf/caddies.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/scorecards',
    name: 'golf_scorecards',
    component: () => import('@/views/admin/golf/scorecards.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/handicaps',
    name: 'golf_handicaps',
    component: () => import('@/views/admin/golf/handicaps.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/players-summary',
    name: 'golf_players_summary',
    component: () => import('@/views/admin/golf/players_summary.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/tournaments',
    name: 'golf_tournaments',
    component: () => import('@/views/admin/golf/tournaments/TournamentsMain.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/course-agreements',
    name: 'golf_course_agreements',
    component: () => import('@/views/admin/golf/CourseAgreementsList.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/course-agreements/manage',
    name: 'golf_course_agreements_manage',
    component: () => import('@/views/admin/golf/CourseAgreementsAdmin.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/convenios',
    name: 'golf_convenios',
    component: () => import('@/views/admin/golf/convenios/GolfConvenios.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/convenios/listado',
    name: 'golf_convenios_listado',
    component: () => import('@/views/admin/golf/convenios/GolfConveniosList.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/convenios/tipos',
    name: 'golf_convenios_tipos',
    component: () => import('@/views/admin/golf/convenios/GolfConveniosTipos.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/convenios/campos',
    name: 'golf_convenios_campos',
    component: () => import('@/views/admin/golf/convenios/GolfConveniosCampos.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/sports-area/:areaId/checkin',
    name: 'area_checkin',
    component: () => import('@/views/admin/sports_area/area_checkin.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/teacher/my-areas',
    name: 'teacher_my_areas',
    component: () => import('@/views/teacher/my-areas.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/offline',
    name: 'offline',
    component: () => import('../views/common/offline.vue')
  },
  {
    path: '/golf/marshall/outings',
    name: 'golf_marshall_outings',
    component: () => import('@/views/admin/golf/marshall_outings.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/marshall/starter-order',
    name: 'golf_marshall_starter_order',
    component: () => import('@/views/admin/golf/marshall_starter_order.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/marshall/warnings',
    name: 'golf_marshall_warnings',
    component: () => import('@/views/admin/golf/marshall_warnings.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/academy',
    name: 'academy_dashboard',
    component: () => import('@/views/academy/academy_dashboard.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/academy/teachers',
    name: 'academy_teachers',
    component: () => import('@/views/academy/academy_teachers.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/academy/clinics',
    name: 'academy_clinics',
    component: () => import('@/views/academy/academy_clinics.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/academy/students',
    name: 'academy_students',
    component: () => import('@/views/academy/academy_students.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/caddie-house',
    name: 'golf_caddie_house',
    component: () => import('@/views/admin/golf/caddie_house.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/golf/garage',
    name: 'golf_garage',
    component: () => import('@/views/admin/golf/garage.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/gym',
    name: 'gym',
    component: () => import('@/views/admin/gym.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/admin/coach-routines',
    name: 'coach_routines',
    component: () => import('@/views/admin/coach_routines.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/admin/member-workout-plan',
    name: 'member_workout_plan',
    component: () => import('@/views/admin/member_workout_plan.vue'),
    beforeEnter: ifAuthenticated
  },
  {
    path: '/partners-register/:inviter_token',
    name: 'partners_register',
    component: () => import('@/views/PartnersRegister.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
